<div [formGroup]="form" class="informate_select_wrapper">
    <mat-label class="font-style" [ngbTooltip]="misalignmentFactor_tooltip" placement="right" container="body" tooltipClass="custom-tooltip">
        <!-- Misalignment Factor -->
        {{ 'CLAMP_PAGE.LABELS.CALC_INPUT.MISALIGNMENT_FACTOR' | transloco }}
    </mat-label>
    <!--tool-tip template start-->
    <ng-template #misalignmentFactor_tooltip>
        <p>
            {{ 'TOOLTIP.INFORMATE_CALC_LABELS.MISALIGNMENT_FACTOR' | transloco }}
        </p>
    </ng-template>
    <!--tool-tip template end-->
    <mat-select formControlName="misalignmentFactor" name="misalignmentFactor" class="input-select">
        <mat-option class="option-list" *ngFor="let x of optionList | keyvalue" [value]="x.value">{{ x.key }}</mat-option>
    </mat-select>
</div>
